import React, { Component } from 'react';
import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton } from '~/commonComponents';

const sectionHeadingStyle = { marginTop: 24, marginBottom: 8 };
const paragraphStyle = { marginBottom: 8 };

export default class About extends Component {
  render() {
    return (
      <Screen variant="standard" ref={(element) => (this.divRef = element)}>
        <Screen.Header start={<BackButton />} title="About" />
        <Screen.Body>
          <Typography size="body_large" color={colors.neutral[600]}>
            GoTu is a faster, easier way to keep your dental office fully staffed. Post a shift and
            connect on demand with licensed, verified dental professionals in your area — whether
            you are covering an unexpected absence, a planned vacation, or simply need an extra set
            of hands. Today, tomorrow, or months from now, GoTu has you covered.
          </Typography>

          <Typography size="heading_3" bold color={colors.primary[500]} style={sectionHeadingStyle}>
            Built for dental offices
          </Typography>
          <Typography size="body_large" color={colors.neutral[600]} style={paragraphStyle}>
            Reach a nationwide network of licensed dental professionals right from your phone or
            desktop. You set the schedule and the hourly rate, and GoTu works in the background to
            fill your shift quickly. No more sub lists, unreliable message boards, or overpriced
            staffing agencies — just qualified professionals on demand so your office never misses a
            beat.
          </Typography>

          <Typography size="heading_3" bold color={colors.primary[500]} style={sectionHeadingStyle}>
            How it works
          </Typography>
          <Typography size="body_large" color={colors.neutral[600]} style={paragraphStyle}>
            Post your open shift in seconds and review professionals as they apply. Approve the ones
            that fit your office, and they will arrive ready to work. Once the day is complete and
            you confirm it, payment is handled automatically through the app — no checks and no
            paperwork. After each shift you can rate your professional and add them to your
            favorites, making it easy to rebook the people your team loves working with.
          </Typography>

          <Typography size="heading_3" bold color={colors.primary[500]} style={sectionHeadingStyle}>
            Verified professionals you can trust
          </Typography>
          <Typography size="body_large" color={colors.neutral[600]}>
            Every professional on GoTu is licensed and verified before they can pick up a shift, so
            you can feel confident about who walks through your door. GoTu was designed to simplify
            and streamline the slow, frustrating process of finding temporary coverage — quick,
            easy, and cost effective.
          </Typography>
        </Screen.Body>
      </Screen>
    );
  }
}
